import LineString from "ol/geom/LineString";
import { toLonLat, fromLonLat } from "ol/proj";
export const lineStringToLatLngs = (line) => line.getCoordinates().map(c => toLonLat(c)).map(([a, b]) => [b, a]);
export const trackToGeometry = (track) => new LineString(track.points.map(([lat, lng]) => fromLonLat([lng, lat])));
export const getTrackImportLink = async (track) => {
    const copy = { ...track };
    delete copy.distance;
    delete copy.elevations;
    delete copy.id;
    const json = JSON.stringify(copy);
    return `${window.location.origin}#page=importTrack/${encodeURIComponent(json)}`;
};
